import {useSelector} from "react-redux";
import {type Control, type FieldValues} from "react-hook-form";

import {useI18n} from "i18n/i18n";
import {DropdownController, Input} from "webform/components";
import {userPersonaSelector} from "webform/store/selectors";
import {userPersonaBuilder, type UserPersonaItem} from "webform/utils";
import {SupportContactFormService} from "webform/gen/supportContactForm";

interface OwnProps {
    control: Control<FieldValues> | undefined;
    user_persona: UserPersonaItem | null;
}

export const UserPersonaCombined = ({control, user_persona}: OwnProps) => {
    const i18n = useI18n();
    const userPersonas = useSelector(userPersonaSelector);

    return (
        <>
            <DropdownController
                label={i18n("webform.fields.i_am_a")}
                required
                fieldName="user_persona_primary"
                placeholder={i18n("webform.fields.role_placeholder")}
                groupedItems={userPersonaBuilder(userPersonas)}
                control={control}
            />
            {user_persona?.type === SupportContactFormService.UserPersonaDataType.SINGLE &&
                user_persona.additional_input && (
                    <Input fieldName="user_persona_description" control={control} required grouped />
                )}
            {user_persona?.type === SupportContactFormService.UserPersonaDataType.GROUP && (
                <DropdownController
                    label={user_persona.id}
                    required
                    fieldName="user_persona_secondary"
                    placeholder={i18n("webform.fields.role_placeholder")}
                    items={user_persona.group}
                    control={control}
                />
            )}
        </>
    );
};
